import { alwaysTrue } from 'utils/data';

import { formatDateValue } from '../PostClosing.utils';

export const getPreConditionsTableConfig = ({ isEditAllowed, renderActions } = {}) => ({
  conditionText: {
    label: 'Condition',
    width: '40%',
  },
  dateAdded: {
    label: 'Date Added',
    width: '15%',
    content: row => formatDateValue(row.dateAdded),
    renderContentAsText: alwaysTrue,
  },
  dateResponded: {
    label: 'Date Responded',
    width: '15%',
    content: row => formatDateValue(row.dateResponded),
    renderContentAsText: alwaysTrue,
  },
  dateCleared: {
    label: 'Date Cleared',
    width: '15%',
    content: row => formatDateValue(row.dateCleared),
    renderContentAsText: alwaysTrue,
  },
  ...(isEditAllowed && {
    actions: {
      label: '',
      width: '80px',
      content: renderActions,
    },
  }),
});
